module.exports = {"TXTWCL_Your_voucher_amount":{"id":"TXTWCL_Your_voucher_amount","defaultMessage":"Το ποσό του κουπονιού σου","track":"Your voucher amount"}}